var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopMiddleStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 86,
    viewBox: "0 0 105 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10885 61.5042C7.96753 61.4144 9.40147 59.835 9.31171 57.9763C9.22196 56.1176 7.6425 54.6837 5.78383 54.7735C3.92515 54.8632 2.49122 56.4427 2.58097 58.3013C2.67073 60.16 4.25018 61.594 6.10885 61.5042Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6326 7.60434C30.7839 7.54875 31.672 6.57058 31.6164 5.41929C31.5608 4.26799 30.5826 3.37993 29.4313 3.43552C28.28 3.49112 27.392 4.46931 27.4476 5.6206C27.5031 6.77121 28.4813 7.65994 29.6326 7.60434Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3131 83.8168C34.4644 83.7612 35.3524 82.783 35.2968 81.6317C35.2412 80.4804 34.263 79.5924 33.1117 79.648C31.9605 79.7036 31.0724 80.6817 31.128 81.833C31.1836 82.9836 32.1618 83.8724 33.3131 83.8168Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.468 59.9112C103.524 61.0623 102.635 62.0406 101.484 62.0962C100.333 62.1518 99.3547 61.2637 99.2991 60.1125C99.2436 58.9613 100.132 57.983 101.283 57.9274C102.434 57.8718 103.412 58.76 103.468 59.9112Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3235 17.9708C87.199 18.4033 90.3594 21.2732 91.1633 25.0883C91.5958 21.2128 94.4656 18.0524 98.2807 17.2485C94.4052 16.8161 91.2449 13.9462 90.441 10.1311C90.0085 14.0066 87.1387 17.167 83.3235 17.9708Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMiddleStars);
export default __webpack_public_path__ + "static/media/top-middle-stars.fc636a283714d76c4a918be216de8c70.svg";
export { ForwardRef as ReactComponent };